import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Row } from "antd";
import moment from "moment";

import partnersApi from "../../../apis/Partners.api";
import { isEndWithConsonant } from "../../../utils/status";
import { loginLog } from "../../../utils/useUser";
// import GroupBuyingHardCoding from "./GroupBuyingHardCoding";

const NowGroupBuying = ({ nowList, readyList, setAlertShow, type }) => {
	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const descriptionList = nowList?.map((item) => [
		item?.usp,
		item?.information_1,
		item?.information_2,
		item?.information_3,
		item?.information_4,
		item?.information_5,
		item?.information_6,
	]);

	/**
	 * 구매하러가기 -> 클릭 수 count
	 * @param item
	 * @returns {Promise<void>}
	 */
	const moveToPurchase = async (item) => {
		const inflow = document?.referrer ?? null;
		loginLog(
			{ id: 8080 },
			`participation_cooperate-${item?.target_id}`,
			inflow
		);
		if (item.product_id) {
			if (item?.cooperate_query) {
				window.open(
					`https://www.dangyoung.com/products/group_buying/${item.target_id}?query=${item?.cooperate_query}`
				);
				if (item?.participate_id) {
					await partnersApi.addGroupBuyingClick({
						targetId: item?.participate_id,
					});
				}
			}
		}

		// 인스타 인앱 브라우저 시 오류 발생
		// 1) product_id 관련 else 문에서 빠져나와서 로직 태움
		// 2) window.open 관련해서 해당 url 을 '_blank' 를 통해 강제로 새 창 띄워주기 적용
		if (item?.purchase_url) {
			window.open(item.purchase_url, "_blank");
			// await partnersApi.addGroupBuyingClick({ targetId: item.target_id });
			if (item?.participate_id) {
				await partnersApi.addGroupBuyingClick({
					targetId: item?.participate_id,
				});
			}
		}
	};

	if (nowList?.length) {
		return (
			<>
				{nowList?.map((item, idx) => {
					if (item.cooperate_query !== "CgpjKmQ7") {
						return (
							<div
								key={`group-buying-${type} ${idx}`}
								className={`home-each ${idx === 0 ? "home-each-by-quick" : ""}`}
							>
								<div className={`max-width-apply home-group-buying`}>
									<div className={`home-recommend-vertical`}>
										<div className={`home-recommend-horizontal`}>
											<div className={`recommend-title`}>
												<p className={`type-kr`}>
													{reduxChannel?.user_id === 8 ||
													reduxChannel?.user_id === 9
														? "갑오징어들을 위한 이벤트!"
														: "공동구매"}
												</p>
												{reduxChannel?.user_id === 8 ||
												reduxChannel?.user_id === 9 ? (
													<p className={`title`}>
														{reduxChannel?.name}
														{isEndWithConsonant(reduxChannel?.name)
															? "이"
															: "가"}{" "}
														준비한{"\n"}
														이벤트
													</p>
												) : (
													<p className={`title`}>
														{reduxChannel?.name}
														{isEndWithConsonant(reduxChannel?.name)
															? "과"
															: "와"}{" "}
														함께하는{"\n"}공동구매
													</p>
												)}
												<p
													className={`type-gray`}
													style={{
														color: "#fb9b51",
														fontWeight: "bold",
														fontSize: "1.2em",
													}}
												>
													기간 |{" "}
													{moment(item.cooperate_start_date)?.format(
														"YYYY.MM.DD"
													)}{" "}
													- {moment(item.cooperate_end_date)?.format("MM.DD")}
												</p>
											</div>
											<Row style={{ gap: "1em" }}>
												{type === "now" && (
													<Button
														className={`home-group-buying-btn black`}
														onClick={() => {
															moveToPurchase(item);
														}}
													>
														{reduxChannel?.user_id === 8 ||
														reduxChannel?.user_id === 9
															? "이벤트"
															: "공동구매"}{" "}
														구매하기
													</Button>
												)}
												<Button
													className={`home-group-buying-btn ${
														type !== "now" ? "black" : ""
													}`}
													onClick={() => setAlertShow(true)}
												>
													{reduxChannel?.user_id === 8 ||
													reduxChannel?.user_id === 9
														? "이벤트"
														: "공동구매"}{" "}
													소식받기
												</Button>
											</Row>
										</div>
										<div className={`home-recommend-horizontal`}>
											<div
												className={`group-buying-product-body`}
												onClick={() => {
													if (mediaResult) {
														moveToPurchase(item);
													}
												}}
											>
												<div className={`product-div`}>
													<div style={{ paddingBottom: "1em" }}>
														<p className={`brand-name`}>
															{item.product_brand_name}
														</p>
														<p className={`product-name`}>
															{item.product_name}
														</p>
													</div>
													{item?.product_id ? (
														<div className={`product-option-list`}>
															{item.optionList?.map((option, idx) => {
																if (option?.is_cooperate)
																	return (
																		<div
																			key={`공동구매 옵션 가격 ${idx}`}
																			className={`product-option-each`}
																		>
																			<p className={`option-title`}>
																				{option?.option_title}
																			</p>
																			<div className={`product-price-div`}>
																				<p className={`origin-price`}>
																					정상가{" "}
																					{option?.price_1?.toLocaleString()}원
																				</p>
																				<div className={`price-discount`}>
																					{/*{type === "now" ? (*/}
																					{/*	<>*/}
																					<p className={`best-price`}>
																						{option?.price_2?.toLocaleString()}
																						원
																					</p>
																					<p className={`discount`}>
																						{option?.discount}%
																					</p>
																					{/*	</>*/}
																					{/*) : (*/}
																					{/*	<p className={`best-price`}>?원</p>*/}
																					{/*)}*/}
																				</div>
																			</div>
																		</div>
																	);
															})}
														</div>
													) : (
														<div className={`product-option-list`}>
															{item.cooperateOptionList?.map((option, idx) => (
																<div
																	key={`공동구매 옵션 가격 ${idx}`}
																	className={`product-option-each`}
																>
																	<p className={`option-title`}>
																		{option?.option_title}
																	</p>
																	<div className={`product-price-div`}>
																		<p className={`origin-price`}>
																			정상가 {option?.price_1?.toLocaleString()}
																			원
																		</p>
																		<div className={`price-discount`}>
																			{/*{type === "now" ? (*/}
																			{/*	<>*/}
																			<p className={`best-price`}>
																				{option?.price_2?.toLocaleString()}원
																			</p>
																			<p className={`discount`}>
																				{option?.discount}%
																			</p>
																			{/*	</>*/}
																			{/*) : (*/}
																			{/*	<p className={`best-price`}>?원</p>*/}
																			{/*)}*/}
																		</div>
																	</div>
																</div>
															))}
														</div>
													)}
												</div>
												<div className={`product-image`}>
													<img
														src={
															item.product_id
																? `${process.env.REACT_APP_S3_HOST}/image/recommend/${item?.target_id}.jpg`
																: `${process.env.REACT_APP_S3_HOST}/image/together/group_buying/${item?.target_id}.jpg`
														}
														onError={({ currentTarget }) => {
															currentTarget.onerror = null; // prevents looping
															// currentTarget.style.display = "none";
															currentTarget.src = `/assets/images/no-product.png`;
														}}
														alt={`${item.product_brand_name} ${item.product_name}`}
													/>
												</div>
											</div>
										</div>
									</div>
									{/*{descriptionList?.map((descriptionEach, dInx) => (*/}
									<div
										className={`product-description`}
										// key={`product-description-${dInx}`}
									>
										{/* eslint-disable-next-line array-callback-return */}
										{descriptionList[idx]?.map((each, index) => {
											if (each)
												return (
													<div
														className={`product-description-each`}
														key={`product-description-each-${index}`}
													>
														{index === 0 ? (
															<p className={`description-title`}>제품 요약</p>
														) : (
															<p className={`description-title`}>
																특징 0{index}
															</p>
														)}
														<p>{each}</p>
													</div>
												);
										})}
									</div>
									{/*))}*/}
								</div>
							</div>
						);
					} else {
						return (
							<div className={`home-each`} key={`group-buying-${type} ${idx}`}>
								<div className={`max-width-apply home-group-buying`}>
									<div
										className={`group-buying-product-banner-body`}
										style={{
											background: `url('/assets/images/products/4856-bg.png') center bottom / cover no-repeat`,
											alignItems: "center",
											justifyContent: "space-around",
											cursor: "pointer",
										}}
										onClick={() => {
											const inflow = document?.referrer ?? null;
											window.open(
												"https://www.dangyoung.com/products/group_buying/4856?query=CgpjKmQ7",
												"_blank"
											);
											loginLog({ id: 8081 }, `product_link-CgpjKmQ7`, inflow);
										}}
									>
										<div>
											<p>자연에서 온 천연 종합비타민</p>
											<h2>
												고순도 고함량 더블랙맥주효모환{"\n"}10% 추가 할인
												이벤트!
											</h2>
										</div>
										<div className={`product-banner-image-div`}>
											<img
												src={`/assets/images/products/4856.png`}
												alt={`맥주효모 배너`}
											/>
										</div>
									</div>
								</div>
							</div>
						);
					}
				})}
			</>
		);
	} else if (type === "now" && !nowList?.length && !readyList?.length) {
		return (
			<div
				className={`home-each ${
					reduxChannel?.user_id ? "home-each-by-quick" : ""
				}`}
			>
				<div className={`max-width-apply home-group-buying`}>
					<div className={`home-recommend-vertical`}>
						<div className={`home-recommend-horizontal`}>
							<div className={`recommend-title`}>
								<p className={`type-kr`}>
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "갑오징어들을 위한 이벤트!"
										: "공동구매"}
								</p>
								{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9 ? (
									<p className={`title`}>
										{reduxChannel?.name}
										{isEndWithConsonant(reduxChannel?.name) ? "이" : "가"}{" "}
										준비한{"\n"}
										이벤트
									</p>
								) : (
									<p className={`title`}>
										{reduxChannel?.name}
										{isEndWithConsonant(reduxChannel?.name) ? "과" : "와"}{" "}
										함께하는{"\n"}공동구매
									</p>
								)}

								<p className={`type-gray`}>
									다음{" "}
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "갑오징어들을 위한 이벤트"
										: "공동구매"}{" "}
									준비 중
								</p>
							</div>
							<Row style={{ gap: "1em" }} className={`mobile-noShow`}>
								<Button
									className={`home-group-buying-btn black`}
									onClick={() => setAlertShow(true)}
								>
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "이벤트"
										: "공동구매"}{" "}
									소식받기
								</Button>
							</Row>
						</div>
						<div className={`home-recommend-horizontal`}>
							{/*{reduxChannel?.user_id === 7 ? (*/}
							{/*    <div*/}
							{/*        className={`group-buying-product-body done-group-buying`}*/}
							{/*        style={{*/}
							{/*            background: `url('/assets/images/channel/event/hercules-end.jpg') center bottom / cover no-repeat`,*/}
							{/*            padding: "2.2em"*/}
							{/*        }}*/}
							{/*    >*/}
							{/*        <p style={{*/}
							{/*            fontSize: "2em",*/}
							{/*            color: "white",*/}
							{/*            fontWeight: "bold",*/}
							{/*            letterSpacing: "-0.66px",*/}
							{/*        }}>*/}
							{/*            공동구매 조기 품절 안내*/}
							{/*        </p>*/}
							{/*        <p style={{*/}
							{/*            fontSize: "1.1em",*/}
							{/*            color: "white",*/}
							{/*            fontWeight: "500",*/}
							{/*            letterSpacing: "-0.66px",*/}
							{/*        }}>*/}
							{/*            많은 분들과 함께하고 싶어 수량을{"\n"}*/}
							{/*            넉넉히 준비했으나 뜨거운 성원에 힘입어{"\n"}*/}
							{/*            헤라클레스 아르기닌 6000이 조기 품절되었습니다!{"\n"}*/}
							{/*            더 좋은 공동구매로 돌아오겠습니다.{"\n"}*/}
							{/*            감사합니다!{"\n"}*/}
							{/*            {"\n"}*/}
							{/*            - 약사 메디슨맨 올림-*/}
							{/*        </p>*/}
							{/*    </div>*/}
							{/*) : (*/}
							<div className={`group-buying-product-body done-group-buying`}>
								<img
									src={`/assets/images/channel/timer.png`}
									alt={`공동구매`}
									className={`group-buying-alert-icon`}
									style={{
										height: "auto",
										width: "1.6em",
									}}
								/>
								<p>
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "이벤트"
										: "공동구매"}
									가 성황리에 마무리 되었습니다.{"\n"}다음{" "}
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "이벤트"
										: "공동구매"}{" "}
									소식도 놓치지 않도록 소식 받아보세요!
								</p>
							</div>
							{/* )}*/}
							<Row style={{ gap: "1em" }} className={`mobile-show`}>
								<Button
									className={`home-group-buying-btn black`}
									onClick={() => setAlertShow(true)}
									style={{
										maxWidth: "100%",
									}}
								>
									{reduxChannel?.user_id === 8 || reduxChannel?.user_id === 9
										? "이벤트"
										: "공동구매"}{" "}
									소식받기
								</Button>
							</Row>
						</div>
					</div>
				</div>
			</div>
		);
	} else return <></>;
};
export default NowGroupBuying;
